// src/components/strumenti/TempoRiempimento.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function TempoRiempimento() {
  const [volume, setVolume] = useState("");
  const [portata, setPortata] = useState("");

  const V = leggiNumero(volume)||0;
  const Q = leggiNumero(portata)||0;
  const minuti = Q>0 ? V/Q : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Volume da riempire (litri)</label>
          <input value={volume} onChange={e=>setVolume(e.target.value)} style={inp} placeholder="Es. 1000"/>
        </div>
        <div>
          <label style={lbl}>Portata disponibile (l/min)</label>
          <input value={portata} onChange={e=>setPortata(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
      </div>

      <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Tempo di riempimento</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#2563eb" }}>
          {minuti===null ? "—" : minuti.toLocaleString("it-IT",{maximumFractionDigits:1})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>minuti</span>
        </div>
        {minuti!==null && minuti>=60 && (
          <div style={{ fontSize:12, color:"#6b7280", marginTop:4 }}>≈ {(minuti/60).toLocaleString("it-IT",{maximumFractionDigits:1})} ore</div>
        )}
      </div>

      <button onClick={()=>{setVolume("");setPortata("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
